const initialState = {
  refreshInventory: false,
  refreshGroups: false,
  inventory: [],
  loadingInventory: true,
  groupedListings: [],
  groupedListingsFirstLoad: false,
  loadingGroupedListings: true,
  groupsOpenned: [],
  groupFocused: null,
};

function refreshGroupsInventory(state = initialState, action) {
  switch (action.type) {
    case 'REFRESH_INVENTORY':
      return { ...state, refreshInventory: true };
    case 'RESET_REFRESH_INVENTORY':
      return { ...state, refreshInventory: false };
    case 'REFRESH_GROUPS':
      return { ...state, refreshGroups: true };
    case 'RESET_REFRESH_GROUPS':
      return { ...state, refreshGroups: false };
    case 'INVENTORY_FETCH_SUCCESS':
      return { ...state, inventory: action.payload };
    case 'LOADING_INVENTORY':
      return { ...state, loadingInventory: action.payload };
    case 'GROUPED_LISTINGS_FETCH_SUCCESS':
      return { ...state, groupedListings: action.payload, groupedListingsFirstLoad: true };
    case 'LOADING_GROUPED_LISTINGS':
      return { ...state, loadingGroupedListings: action.payload };
    case 'SET_GROUPS_OPENNED':
      return { ...state, groupsOpenned: action.payload };
    case 'SET_GROUPS_FOCUSED':
      return { ...state, groupFocused: action.payload };
    default:
      return state;
  }
}

export default refreshGroupsInventory;
